var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.037,
    height: 30.91,
    viewBox: "0 0 27.037 30.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.412,17.045a1,1,0,0,1,.5.134L47.949,31.634a1,1,0,0,1,0,1.732L22.912,47.821a1,1,0,0,1-1.5-.866V18.045a1,1,0,0,1,1-1ZM45.449,32.5,23.412,19.777V45.223Z",
    transform: "translate(-21.412 -17.045)",
    fill: "#0b5fa3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.fe8759026d8314ca7aae6ea9820f8174.svg";
export { ForwardRef as ReactComponent };